import { GroupCol, GroupRow } from '../types';

export function getAllowedColRowGroups(
  mode: 'unified' | 'classic',
  isProgression: boolean,
): { groupRow: GroupRow; groupCol: GroupCol }[] {
  if (mode === 'unified') {
    if (isProgression) {
      return [
        { groupCol: 'matieres', groupRow: 'semaines' },
        { groupCol: 'semaines', groupRow: 'matieres' },
      ];
    }
    return [
      { groupCol: 'matieres', groupRow: 'periodes' },
      { groupCol: 'periodes', groupRow: 'matieres' },
    ];
  }
  if (isProgression) {
    return [
      { groupCol: 'domaines', groupRow: 'semaines' },
      { groupCol: 'semaines', groupRow: 'domaines' },
    ];
  }
  return [
    { groupCol: 'domaines', groupRow: 'periodes' },
    { groupCol: 'periodes', groupRow: 'domaines' },
  ];
}
